import { FC } from 'react';
import { Select } from '@headlessui/react';

export type ComparisonThreshold = 'ch' | 'word' | 'para';

interface ThresholdSelectorProps {
  value: ComparisonThreshold;
  onChange: (value: ComparisonThreshold) => void;
  className?: string;
}

const ThresholdSelector: FC<ThresholdSelectorProps> = ({
  value,
  onChange,
  className = '',
}) => {
  return (
    <label className="flex items-center gap-1.5 text-xs font-medium text-mainblue">
      <span>Compare by:</span>
      <Select
        name="comparison-threshold"
        aria-label="Comparison threshold"
        value={value}
        onChange={(event) =>
          onChange((event.target.value || 'word') as ComparisonThreshold)
        }
        className={`min-w-[7rem] rounded border border-mainblue/40 bg-white px-2 py-0.5 text-xs font-medium text-mainblue shadow-sm focus:outline-none focus:ring-1 focus:ring-mainblue data-focus:ring-mainblue data-hover:shadow-sm ${className}`}
      >
        <option value="ch">Character</option>
        <option value="word">Word</option>
        <option value="para">Paragraph</option>
      </Select>
    </label>
  );
};

export default ThresholdSelector;
